import { render, staticRenderFns } from "./hello.vue?vue&type=template&id=53be5844&scoped=true&"
import script from "./hello.vue?vue&type=script&lang=js&"
export * from "./hello.vue?vue&type=script&lang=js&"
import style0 from "./hello.vue?vue&type=style&index=0&id=53be5844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be5844",
  null
  
)

export default component.exports